module.exports = __webpack_public_path__ + "img/SC2-Disclaimer.dda660e5.png";